<script setup lang="ts">
import { useQueryClient } from '@tanstack/vue-query';

const { filters } = usePudos();
const queryClient = useQueryClient();
const distance = [1, 5, 10, 15, 20];

watch(() => filters, () => {
  queryClient.invalidateQueries({ queryKey: ['pudos'] });
}, { deep: true });
</script>

<template>
  <div class="flex gap-2 mb-4">
    <button
      class="h-7 px-3 rounded-sm border"
      :class="{ 'bg-primary text-white': filters.to.value == dist }"
      v-for="(dist, index) in distance"
      :key="index"
      @click="filters.to.value = dist"
    >
      {{ dist }} km
    </button>
  </div>
</template>
